module.exports = __webpack_public_path__ + "media/images/Fija-resized-948a163f93a945543f70217bbd3e8b4f.png";